<app-wrapper class="media-library-page" [hideServices]="true">
  <div class="service-content {{store.state.common.sidemenuSmall ? 'sidemenu-small' : ''}} container-fluid h-100">
    <div class="row pt-5 px-3 w-100 m-0">
      <div class="col-12">
        <div class="row list-header my-0 align-items-center">
          <div class="col">
            <h1 class="list-header-title mb-1">{{ 'Media library' | translate }}</h1>
            <p class="text-muted mb-0 small">
              {{ 'Files referenced by Download file actions across services.' | translate }}
            </p>
          </div>
          <div class="col-auto">
            <button type="button" class="btn btn-sm btn-secondary"
                    (click)="refresh()" [disabled]="loading">
              <i class="far fa-sync mr-1" [class.fa-spin]="loading"></i>
              {{ 'Refresh' | translate }}
            </button>
          </div>
        </div>

        <div *ngIf="blockingUsages" class="alert alert-warning mt-3 media-library-blocking" role="alert">
          <div class="d-flex align-items-start">
            <i class="far fa-exclamation-triangle mr-2 mt-1"></i>
            <div class="flex-grow-1">
              <div class="font-weight-bold mb-1">
                {{ 'Cannot delete — file is referenced by' | translate }}
                {{ blockingUsages.usages.length }}
                {{ (blockingUsages.usages.length === 1 ? 'action' : 'actions') | translate }}
              </div>
              <div class="text-muted small mb-2">
                {{ 'Open each service and remove the Download file action before retrying.' | translate }}
              </div>
              <ul class="list-unstyled mb-0 media-library-blocking__list">
                <li *ngFor="let u of blockingUsages.usages" class="d-flex align-items-center py-1">
                  <i class="far fa-arrow-right text-muted mr-2"></i>
                  <span class="mr-1">{{ 'Button' | translate }}</span>
                  <span class="media-library-blocking__btn mr-2">{{ u.componentName || u.componentKey }}</span>
                  <span class="text-muted mr-1">{{ 'in' | translate }}</span>
                  <a [routerLink]="usageLink(u)"
                     [queryParams]="usageQueryParams(u)"
                     [fragment]="usageFragment(u)"
                     target="_blank"
                     rel="noopener"
                     class="font-weight-medium"
                     [tooltip]="usageTooltip(u) | translate"
                     placement="top">
                    {{ usageTargetLabel(u) }}
                    <i class="far fa-external-link ml-1" style="font-size: 0.75em;"></i>
                  </a>
                </li>
              </ul>
            </div>
            <button type="button" class="btn btn-sm btn-link text-muted ml-2"
                    (click)="blockingUsages = null"
                    [attr.aria-label]="'Dismiss' | translate">
              <i class="far fa-times"></i>
            </button>
          </div>
        </div>

        <div class="mt-4">
          <file-handler
            *ngFor="let slot of uploadSlot; trackBy: trackBySlot"
            apiBasePath="media"
            accept="*/*"
            label="{{ 'Upload a new file' | translate }}"
            description="{{ 'Drag and drop or click to browse. Files will be available across all services.' | translate }}"
            (fileIdChanged)="onUploaded($event)"></file-handler>
        </div>

        <div *ngIf="files.length > 0" class="mt-4 d-flex flex-column" style="gap: 12px;">
          <file-handler
            *ngFor="let f of files; trackBy: trackById"
            [fileId]="f.id"
            apiBasePath="media"
            [showCopyUrl]="true"
            (delete)="delete(f)"></file-handler>
        </div>

        <div *ngIf="!loading && files.length === 0" class="text-center text-muted mt-4 py-4">
          <i class="far fa-folder-open d-block mb-2" style="font-size: 2.5rem; opacity: 0.4;"></i>
          {{ 'No files yet.' | translate }}
        </div>
      </div>
    </div>
  </div>
</app-wrapper>
